// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bvYp_","right":"styles_right__Jl9r-"};